import { useMutation, useQueryClient } from 'react-query';
import revertToActiveListing from '../workflows/revertToActiveListing';
import { callRefetchAllTasks } from 'resources/task/task.helpers';


export default function useRevertToActiveListing() {
  const queryClient = useQueryClient();
  const currentUser = queryClient.getQueryData(['user.currentUser']);

  return useMutation(
    (dealId) => revertToActiveListing(dealId, currentUser?.id),
    {
      onSuccess: async (response) => {
        if (!response?.data?.[0]?.id || response.isBadRequest || !currentUser) {
          return;
        }

        const updatedDealId = response.data[0].id;
        
        callRefetchAllTasks({
          queryClient,
          userIds: [currentUser.id],
          companyId: currentUser.company_id,
          dealId: updatedDealId,
        });

        queryClient.invalidateQueries(['deal-event.getByDealId', updatedDealId]);
      },
    });
}